export default __webpack_public_path__ + "static/media/search.4af6a095.svg";